/**
 * Handles breakpoint detection and triggers callbacks on resize
 * @param {Function} onMobile - Callback triggered when switching to mobile view
 * @param {Function} onDesktop - Callback triggered when switching to desktop view
 * @param {number} breakpoint = 1024 - The mobile breakpoint width
 */
export function handleResponsiveBreakpoint(onMobile?: () => void, onDesktop?: () => void, breakpoint: number = 1024) {
    let isMobile = window.innerWidth <= breakpoint;

    if (isMobile) {
        onMobile?.();
    } else {
        onDesktop?.();
    }

    window.addEventListener("resize", () => {
        const currentIsMobile = window.innerWidth <= breakpoint;

        if (currentIsMobile !== isMobile) {
            isMobile = currentIsMobile;
            if (isMobile) {
                onMobile?.();
            } else {
                onDesktop?.();
            }
        }
    });
}
